import { communityStats } from "@/mocks/site";

export default function StatsSection() {
  return (
    <section className="bg-secondary-100 py-14 md:py-16" aria-label="社区数据">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="flex flex-col gap-3 text-center">
          <h2 className="font-display text-2xl text-foreground-950 md:text-3xl">
            一个每天都在长胖的爆料社区
          </h2>
          <p className="mx-auto max-w-2xl text-sm leading-relaxed text-secondary-800 md:text-base">
            从一条条琐碎的见闻开始，慢慢攒成了现在的样子。下面这些数字，来自每一个愿意开口的人。
          </p>
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {communityStats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center rounded-lg border border-secondary-200 bg-background-50 px-4 py-7"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className={`${stat.icon} text-xl`} aria-hidden="true" />
              </span>
              <dd className="mt-4 flex items-baseline gap-1">
                <span className="font-display text-2xl text-foreground-950 md:text-3xl">{stat.value}</span>
                <span className="font-label text-xs text-foreground-500">{stat.unit}</span>
              </dd>
              <dt className="mt-1 font-label text-xs text-foreground-600">{stat.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}